// This file maps the random names to local asset paths.
// Ensure all images exist in 'src/assets/avatars/' with the exact names below.

export const AvatarMap = {
  "Mystic": require('../assets/avatars/Mystic.png'),
  "Shadow": require('../assets/avatars/Shadow.png'),
  "Echo": require('../assets/avatars/Echo.png'),
  "Blaze": require('../assets/avatars/Blaze.png'),
  "Luna": require('../assets/avatars/Luna.png'),
  "Nova": require('../assets/avatars/Nova.png'),
  "Sky": require('../assets/avatars/Sky.png'),
  "Zephyr": require('../assets/avatars/Zephyr.png'),
  "Raven": require('../assets/avatars/Raven.png'),
  "Vortex": require('../assets/avatars/Vortex.png'),
  "Nebula": require('../assets/avatars/Nebula.png'),
  "Drift": require('../assets/avatars/Drift.png'),
  "Vibe": require('../assets/avatars/Vibe.png'),
  "Frost": require('../assets/avatars/Frost.png'),
  "Phantom": require('../assets/avatars/Phantom.png'),
  "Wraith": require('../assets/avatars/Wraith.png'),
  "Dusk": require('../assets/avatars/Dusk.png'),
  "Haze": require('../assets/avatars/Haze.png'),
  "Storm": require('../assets/avatars/Storm.png'),
  "Rogue": require('../assets/avatars/Rogue.png'),
  "Pulse": require('../assets/avatars/Pulse.png'),
  "Ember": require('../assets/avatars/Ember.png'),
  "Flicker": require('../assets/avatars/Flicker.png'),
  "Shade": require('../assets/avatars/Shade.png'),
  "Bolt": require('../assets/avatars/Bolt.png'),
  "Glimmer": require('../assets/avatars/Glimmer.png'),
  "Surge": require('../assets/avatars/Surge.png'),
  "Flare": require('../assets/avatars/Flare.png'),
  "Cosmo": require('../assets/avatars/Cosmo.png'),
  "Daze": require('../assets/avatars/Daze.png'),
  "Sable": require('../assets/avatars/Sable.png'),
  "Nyx": require('../assets/avatars/Nyx.png'),
  "Rift": require('../assets/avatars/Rift.png'),
  "Glow": require('../assets/avatars/Glow.png'),
  "Specter": require('../assets/avatars/Specter.png'),
  "Chill": require('../assets/avatars/Chill.png'),
  "Havoc": require('../assets/avatars/Havoc.png'),
  "Mist": require('../assets/avatars/Mist.png'),
  "Stryke": require('../assets/avatars/Stryke.png'),
  "Zest": require('../assets/avatars/Zest.png'),
  "Dawn": require('../assets/avatars/Dawn.png'),
  "Volt": require('../assets/avatars/Volt.png'),
  "Crimson": require('../assets/avatars/Crimson.png'),
  "Slate": require('../assets/avatars/Slate.png'),
  "Kaze": require('../assets/avatars/Kaze.png'),
  "Fury": require('../assets/avatars/Fury.png'),
  "Vapor": require('../assets/avatars/Vapor.png'),
  "Glint": require('../assets/avatars/Glint.png'),
  "Rebel": require('../assets/avatars/Rebel.png'),
  "Ash": require('../assets/avatars/Ash.png'),
  "Tide": require('../assets/avatars/Tide.png'),
  "Zenith": require('../assets/avatars/Zenith.png'),
  "Dagger": require('../assets/avatars/Dagger.png'),
  "Star": require('../assets/avatars/Star.png'),
  "Nerve": require('../assets/avatars/Nerve.png'),
  "Blitz": require('../assets/avatars/Blitz.png'),
  "Shadez": require('../assets/avatars/Shadez.png'),
  "Flux": require('../assets/avatars/Flux.png'),
  "Neon": require('../assets/avatars/Neon.png'),
  "Chaos": require('../assets/avatars/Chaos.png'),
  "Verve": require('../assets/avatars/Verve.png'),
  "Rush": require('../assets/avatars/Rush.png'),
  "Grit": require('../assets/avatars/Grit.png'),
  "Faze": require('../assets/avatars/Faze.png'),
  "Drip": require('../assets/avatars/Drip.png'),
  "Hex": require('../assets/avatars/Hex.png'),
  "Jolt": require('../assets/avatars/Jolt.png'),
  "Wisp": require('../assets/avatars/Wisp.png'),
  "Scorch": require('../assets/avatars/Scorch.png'),
  "Vex": require('../assets/avatars/Vex.png'),
  "Hype": require('../assets/avatars/Hype.png'),
  "Frosty": require('../assets/avatars/Frosty.png'),
  "Slash": require('../assets/avatars/Slash.png'),
  "Glaze": require('../assets/avatars/Glaze.png'),
  "Sparkz": require('../assets/avatars/Sparkz.png'),
  "Eclipse": require('../assets/avatars/Eclipse.png'),
  "Raze": require('../assets/avatars/Raze.png'),
  "Sway": require('../assets/avatars/Sway.png'),
  "Phantomz": require('../assets/avatars/Phantomz.png'),
  "Buzz": require('../assets/avatars/Buzz.png'),
  "Quartz": require('../assets/avatars/Quartz.png'),
  "Vivid": require('../assets/avatars/Vivid.png'),
  "RUSH": require('../assets/avatars/RUSHO.png'), 
  "Craze": require('../assets/avatars/Craze.png'),
  "Driftz": require('../assets/avatars/Driftz.png'),
  "Ignite": require('../assets/avatars/Ignite.png'),
  "Frenzy": require('../assets/avatars/Frenzy.png'),
  "Spectral": require('../assets/avatars/Spectral.png'),
  "BlazeX": require('../assets/avatars/BlazeX.png'),
  "Vaporz": require('../assets/avatars/Vaporz.png'),
  "Sting": require('../assets/avatars/Sting.png'),
  "Aurora": require('../assets/avatars/Aurora.png'),
  "Kryo": require('../assets/avatars/Kryo.png'),
};